import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();

var submitIcon = $('.searchbox-icon');
var inputBox = $('.searchbox-input');
var searchBox = $('.search-input-animated');
var isOpen = false;
submitIcon.click(function () {
    if (isOpen == false) {
        searchBox.addClass('searchbox-open');
        inputBox.focus();
        isOpen = true;
    } else {
        searchBox.removeClass('searchbox-open');
        inputBox.focusout();
        isOpen = false;
    }
});
submitIcon.mouseup(function () {
    return false;
});
searchBox.mouseup(function () {
    return false;
});
$(document).mouseup(function () {
    if (isOpen == true) {
        $('.searchbox-icon').css('display', 'block');
        submitIcon.click();
    }
});

// LEADERBOARD SHOW ON SCROLL ONCE

if ($("#leaderboard").length) {

    var lastScrollTop = 0;
    var timer_on = 0;
    var leaderTimeout;

    //$("body").css("padding-top", $("#leaderboard").height() + "px");

    $(window).on('scroll', function (event) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            //leaderboard sticky
            $("#leaderboard").css("position", "fixed");
            var stickyTopDuration = $("#leaderboard").data("duration") * 1000;
            if (!timer_on) {
                timer_on = 1;
                leaderTimeout = setTimeout(function () {
                    $("#leaderboard").slideUp("fast"); //hide leaderboard after 3 seconds 
                }, stickyTopDuration);
            }

        }

        lastScrollTop = st;
        //console.log(st, 'st');

        if (st == 0) {
            clearTimeout(leaderTimeout);
            timer_on = 0;
            $("#leaderboard").css("position", "static");
            $("#leaderboard").show();
        }
    });

}